'use client';
import { useEffect, useState } from 'react';
import Button from '../../../components/common/Button';
import { useNavigate } from 'react-router-dom';
import { useMemberApi } from '../../../hooks/useMemberApi';
import { MemberRegistrationStepConstants } from '../../../constants/MemberRegistrationStepConstants';

export default function PayfastReturn() {
  const params = new URLSearchParams(window.location.search);
  const status = params.get('status'); // success | cancel
  const memberId = params.get('member');
  const back = decodeURIComponent(params.get('back') || '');
  const fallback = '/login'; // default if no back present
  const backgroundImage = '/images/NS_Pattern%201_Navy_2025.webp';
  const target =
    back && back !== 'null' && back !== 'undefined' ? back : fallback;

  const navigate = useNavigate();
  const { updateRegistrationStep } = useMemberApi();

  // Only the registration step is sent; the server ignores this for a member who is no longer a new
  // registration, so a late cancel can't undo a payment that completed in the meantime.
  const handleCancelTransaction = async () => {
    if (!memberId) return;
    try {
      await updateRegistrationStep(memberId, {
        memberRegistrationStepId: MemberRegistrationStepConstants.PAYMENT,
      });
    } catch (error) {
      console.error('Error resetting registration step after cancelled payment', error);
    }
  };

  useEffect(() => {
    if(status === 'cancel')
      handleCancelTransaction();
  }, []);

  useEffect(() => {
    const t = setTimeout(() => {
      window.location.href = target;
    }, 3500);
    return () => clearTimeout(t);
  }, [target]);

  return (
    <div className="relative min-h-screen flex items-center justify-center px-4 py-8 sm:py-12">
      <div
        className="absolute inset-0 w-full min-h-full bg-cover bg-center transition-opacity duration-500 -z-10"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />

      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-lg text-center z-10">
        <img
          src="/images/logo-linnear-navy.png"
          alt="Natshoot Logo"
          className="mx-auto mb-6 w-56"
        />

        <div className="mb-4">
          <h1 className="text-xl font-semibold">
            {status === 'success' ? 'Payment successful' : 'Payment cancelled'}
          </h1>
          <p>You’ll be redirected shortly.</p>
        </div>

        <Button className="mr-3" onClick={() => navigate(target)}>
          Go back now
        </Button>
      </div>
    </div>
  );
}
